/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { LanguageDropdownOption } from 'cio/components/subscription-center/localization/edit';

enum DisplayTypes {
  Options = 'options',
  SelectedItem = 'selectedItem',
}

// Based on how this component is used with FlyPowerSelect (@itemComponent vs.
// @selectedItemComponent) the api can change.
interface LanguageOptionNonSelectedArgs {
  item: LanguageDropdownOption;
  labelProperty: string;
  display: DisplayTypes;
}

interface LanguageOptionSelectedArgs {
  option: LanguageDropdownOption;
  extra: Record<string, any>;
  select: unknown;
  display: DisplayTypes;
}

type LanguageOptionArgs = LanguageOptionNonSelectedArgs | LanguageOptionSelectedArgs;

export default class LanguageOption extends Component<LanguageOptionArgs> {
  displayTypes = DisplayTypes;

  get item() {
    if ('item' in this.args) {
      return this.args.item;
    }

    return this.args.option;
  }

  get labelProperty() {
    if ('labelProperty' in this.args) {
      return this.args.labelProperty;
    }

    return this.args.extra.labelProperty;
  }

  get lcidHasValidCountryCode() {
    return this.item.value.match(/-[A-z]{2}$/);
  }

  get countryCode() {
    if (!this.lcidHasValidCountryCode) {
      return;
    }

    let splitLcid = this.item.value.split('-');

    return splitLcid[splitLcid.length - 1].toLowerCase();
  }
}
